import axios from 'axios';
import moment from 'moment';
import * as utils from "../../_metronic/utils/utils";

export const createFormikValidation = (formMap, values) => {
	const errors = {};


	// array de campos de telefone que devem ser validados
	const camposTelefone = [
		'emp_telefone',
		'cli_telefone',
		'usu_telefone',
		'fil_telefone',
		'pou_telefone',
		'pce_telefone',
		'sup_telefone',
		'pob_telefone',
		'pof_telefone',
		'cep_telefone'
	];

	for (let [key, value] of formMap) {
		if (!values[key] && values[key] !== 0) {
			errors[key] = "O campo " + value + " é obrigatório."
		} else if (key === 'email' && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[key])) {
			errors[key] = "Você precisa informar um e-mail válido.";
		} else if (key === 'password' && values[key].length < 6) {
			errors[key] = "A senha deve ter pelo menos 6 caracteres.";
		} else if (camposTelefone.includes(key) && (!/^\(?\d{2}\)?\s?\d{4,5}-?\d{4}$/.test(values[key])
			|| (values[key].replace(/[()\s-]/g, '').length < 10) // Menos de 10 dígitos (2 de DDD + 8 de telefone fixo)
			|| (values[key].replace(/[()\s-]/g, '').length > 12) // Mais de 11 dígitos (2 de DDD + 9 de celular)
			|| (values[key].replace(/[()\s-]/g, '').charAt(2) != 9 && values[key].replace(/[()\s-]/g, '').length == 11) // Caso seja um celular e não comece com 9
			|| (values[key].replace(/[()\s-]/g, '').charAt(2) == 9 && values[key].replace(/[()\s-]/g, '').length == 10) // Caso seja um fixo e comece com 9
		)) {
			errors[key] = "Você precisa informar um telefone válido.";
		}
	}

	return errors;
};

export const shallowEqual = (object1, object2) => {
	const keys1 = Object.keys(object1);
	const keys2 = Object.keys(object2);

	if (keys1.length !== keys2.length) {
		return false;
	}

	for (let key of keys1) {
		if (object1[key] !== object2[key]) {
			return false;
		}
	}

	return true;
};

export const getTimeIntervalInMinutes = (inicio, fim) => {
	var inicio = inicio;
	var fim = fim;

	var difference = moment(inicio, "HH:mm").diff(moment(fim, "HH:mm"));
	var diferrenceInMs = moment.duration(difference);
	var interval = Math.abs(Math.floor(diferrenceInMs.asMinutes()));

	return interval;
}

export const formatHourInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1:$2");

	input.target.value = value;

	return input;
};

export const formatCNPJInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1/$2");
	value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatCPFInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d)/, "$1.$2");
	value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatDataInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");
	value = value.replace(/(\d{2})(\d)/, "$1/$2");

	input.target.value = value;

	return input;
};

export const formatTelefoneInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{0})(\d)/, "$1($2");
	value = value.replace(/(\d{2})(\d)/, "$1) $2");
	value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatCepInput = input => {
	let value = input.target.value;

	value = value.replace(/\D/g, "");
	value = value.replace(/(\d{5})(\d)/, "$1-$2");

	input.target.value = value;

	return input;
};

export const formatBRLInput = input => {
	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, '')) / 10 ** 2;

	input.target.value = formatBRL(input.target.value);

	return input;
};

export const formatBRL = value => {
	const formatter = new Intl.NumberFormat('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2
	});

	value = formatter.format(value);

	return value;
};

export const formatIntegerInput = input => {
	if (input.target.value == '') {
		input.target.value = '';
		return input;
	}

	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ''));
	return input;
};

export const formatPercentageInput = input => {
	if (input.target.value == '') input.target.value = 0;
	input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ''));
	if (input.target.value == 0) input.target.value = 0;
	if (input.target.value > 100) input.target.value = '100';
	return input;
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf) => {
	if (input.target.value.length > 8) {
		var cep = input.target.value.replace(/[^0-9]/, "");

		const instance = axios.create();

		instance.get(`https://viacep.com.br/ws/${cep}/json/`, {}).then(res => {

			if (res.data.erro) {
				setFieldValue(nomeEndereco, '');
				setFieldValue(nomeBairro, '');
				setFieldValue(nomeCidade, '');
				setFieldValue(nomeUf, "AC");
			} else {
				setFieldValue(nomeEndereco, res.data.logradouro);
				setFieldValue(nomeBairro, res.data.bairro);
				setFieldValue(nomeCidade, res.data.localidade);
				setFieldValue(nomeUf, res.data.uf);
			}
		}).catch(err => {
		});
	}

	return formatCepInput(input);
};

export const limparMoeda = (valor) => {
	valor = valor.replace("R$", "");
	valor = valor.replace(".", "");
	valor = valor.replace(",", ".");
	// eslint-disable-next-line
	valor = valor.replace('/^\p{Z}+|\p{Z}+$/u', '');
	valor = valor.trim();

	return valor
};

export const listaUfs = [
	'AC',
	'AL',
	'AM',
	'AP',
	'BA',
	'CE',
	'DF',
	'ES',
	'GO',
	'MA',
	'MG',
	'MS',
	'MT',
	'PA',
	'PB',
	'PE',
	'PI',
	'PR',
	'RJ',
	'RN',
	'RO',
	'RR',
	'RS',
	'SC',
	'SE',
	'SP',
	'TO'
];

export const displayValueCurrency = (value) => {
	return value ? `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : "Não disponível";
};

export const displayValueFixed = (value, casas) => {
	return value ? value.toFixed(casas) : "Não disponível";
};

export const displayValuePercent = (value) => {
	return value ? `${value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} %` : "Não disponível";
};

export const listControllers = {
	'App\\Http\\Controllers\\Empresa\\AuthController': "Autenticação",
	'App\\Http\\Controllers\\Empresa\\UserGroupController': "Grupo de permissões",
	'App\\Http\\Controllers\\Empresa\\DashboardController': "Dashboard",
	'App\\Http\\Controllers\\Empresa\\AgendamentoController': "Agendamento",
	'App\\Http\\Controllers\\Empresa\\CaixaController': "Caixa",
	'App\\Http\\Controllers\\Empresa\\ComandaController': "Comanda",
	'App\\Http\\Controllers\\Empresa\\ComandaProdutoController': "Bar/Cozinha",
	'App\\Http\\Controllers\\Empresa\\PlanoController': "Plano",
	'App\\Http\\Controllers\\Empresa\\ServicoController': "Serviço",
	'App\\Http\\Controllers\\Empresa\\ProdutoController': "Produto",
	'App\\Http\\Controllers\\Empresa\\FilialController': "Filial",
	'App\\Http\\Controllers\\Empresa\\ClienteController': "Cliente",
	'App\\Http\\Controllers\\Empresa\\RelatorioController': "Relatório",
	'App\\Http\\Controllers\\Empresa\\UsuarioController': "Usuário",
	'App\\Http\\Controllers\\Empresa\\PerfilController': "Perfil",
	'App\\Http\\Controllers\\Empresa\\EstoqueController': "Estoque",
	'App\\Http\\Controllers\\Empresa\\CategoriaController': "Categoria",
};

export const listFunctions = {
	"auth": "Entrar",
	"forgotPassword": "Recuperar senha",
	"resetPassword": "Trocar senha",
	"store": "Cadastrar",
	"update": "Atualizar",
	"get": "Visualizar",
	"delete": "Apagar",
	"getDashboard": "Dados da dashboard",
	"addProdutos": "Adicionar produtos",
	"addServicos": "Adicionar serviços",
	"deleteProdutos": "Remover produtos",
	"deleteServicos": "Remover serviços",
	"addAgendamentos": "Adicionar agendamento",
	"cancelarAgedamento": "Cancelar agendamento",
	"entregar": "Entregar produto",
	"abrirCaixa": "Abrir caixa",
	"fecharCaixa": "Fechar caixa",
	"getComandas": "Comandas no caixa",
	"simpleList": "Lista simples",
	"list": "Listar",
	"simpleListBarbeiro": "Listar profissionais",
	"destroy": "Apagar",
	"getPermissions": "Listar permissões",
	"getDadosFechamento": "Dados para fechamento de caixa",
	"simpleListDiarioByFilial": "Listar agendamentos diário por filial",
	"cancelarAgendamento": "Cancelar",
	"finalizarAgendamento": "Finalizar",
	"fecharComanda": "Fechar",
	"addProduto": "Adicionar produtos",
	"addServico": "Adicionar serviços",
	"deleteProduto": "Remover produtos",
	"deleteServico": "Remover serviços",
	"addAgendamento": "Adicionar agendamento",
	"deleteAgendamento": "Remover agendamentos",
	"getServicoPreco": "Buscar valores de serviço",
	"getRelatorio01": "Financeiro",
	"getRelatorio02": "Comissões de serviços",
	"getRelatorio03": "Agendamentos",
	"getRelatorio04": "Planos",
	"getRelatorio05": "Clientes",
	"getRelatorio06": "Avaliações",
	"getRelatorio08": "Ticket médio do profissional",
	"getRelatorio09": "Cliente por período e serviço",
	"entregarProduto": "Entregar produto",
	"deletePlano": "Cancelar plano",
	"manualPayment": "Adicionar pagamento manual",
	"changeClienteStatus": "Confirmar / Cancelar Agendamento",
	"getCreditCard": "Verificar cartão cadastrado",
	"resizeUpdate": "Alterar data e hora do agendamento.",
	"getProdutoPreco": "Buscar preço do produto",
};

export const getProdutoCategorias = [
	{ key: "COSMETICO", value: "Cosmético" },
	{ key: "BAR", value: "Bar" },
	{ key: "COZINHA", value: "Cozinha" },
	{ key: "OUTROS", value: "Outros" },
];

export const getCategoriasTypes = [
	{ key: "PRODUTO", value: "Produto" },
	{ key: "SERVICO", value: "Serviço" },
]

export const getWeekDays = [
	{
		label: 'Segunda',
		key: 'Segunda'
	},
	{
		label: 'Terça',
		key: 'Terça'
	},
	{
		label: 'Quarta',
		key: 'Quarta'
	},
	{
		label: 'Quinta',
		key: 'Quinta'
	},
	{
		label: 'Sexta',
		key: 'Sexta'
	},
	{
		label: 'Sábado',
		key: 'Sábado'
	},
	{
		label: 'Domingo',
		key: 'Domingo'
	}
];

export const getJanelasAtendimento = [15, 20, 30, 40, 60];

export const getPeriodosAtendimento = [7, 15, 21, 30];

export const getUserTypes = [
	{ key: "ADMIN", value: "Admin" },
	{ key: "BARBEIRO", value: "Profissional" },
];

export const getEstoqueType = [
	{ key: "ENTRADA", value: "Entrada" },
	{ key: "SAIDA", value: "Saída" },
];

export const getFormasPagamento = [
	{ key: "CARTAO_CREDITO", value: "Cartão de crédito" },
	{ key: "CARTAO_DEBITO", value: "Cartão de débito" },
	{ key: "DINHEIRO", value: "Dinheiro" },
	{ key: "PIX", value: "PIX" },
	{ key: "VALE_PRESENTE", value: "Vale presente" },
	{ key: "CORTESIA", value: "Cortesia" },
	{ key: "CONVENIO", value: "Convênio" },
	{ key: "OUTROS", value: "Outros" },
];

export const getTimeZone = (gmt) => {
	switch (localStorage.getItem('timeZone')) {
		case 'GMT-2':
			return 'America/Noronha';
		case 'GMT-4':
			return 'America/Manaus';
		case 'GMT-5':
			return 'America/Rio_Branco';
		default:
			return 'America/Sao_Paulo';
	}
};

export const getFallBackTimeZone = () => {
  console.log("Using FALLBACK OPTION for timeZone\n");
  const offset = new Date().getTimezoneOffset();
  const gmtValue = offset / 60;
  const tz = `GMT${gmtValue > 0 ? "-" : "+"}${Math.abs(gmtValue)}`;
  console.log({ tz });
  return tz;
};

/**
 * Converte uma data para o GMT correto.
 * @param {*} date - O dia, (caso o formato original seja um datetime passar apenas esse parâmetro e o time como null)
 * @param {*} time - O horário 
 * @param {*} format - O formato que deseja ser retornado
 * @param {*} toGMT3 - se true a data será convertida para gmt-3 se false ela irá ser convertida de GMT-3 para a timezone do usuário
 * @returns - A data formatada no GMT correto.
 */
export const convertToGMT = (date, time, format, toGMT3) => {
	let f_datetime = moment();

	if (date && time) {
		f_datetime = moment(date + ' ' + time);
	} else {
		f_datetime = moment(date);
	}

	if (toGMT3) {
		switch (localStorage.getItem('timeZone')) {
			case 'GMT-2':
				f_datetime.subtract(1, 'hour');
				break;
			case 'GMT-4':
				f_datetime.add(1, 'hour');
				break;
			case 'GMT-5':
				f_datetime.add(2, 'hours');
				break;
			default:
				break;
		}
	} else {
		switch (localStorage.getItem('timeZone')) {
			case 'GMT-2':
				f_datetime.add(1, 'hour');
				break;
			case 'GMT-4':
				f_datetime.subtract(1, 'hour');
				break;
			case 'GMT-5':
				f_datetime.subtract(2, 'hours');
				break;
			default:
				break;
		}
	}

	return f_datetime.format(format)
};

export const convertToGMTComLimiteEmMeiaNoite = (date, time, format, toGMT3) => {

	let f_datetime = moment();

	if (date && time) {
		f_datetime = moment(date + ' ' + time);
	} else if (date) {
		f_datetime = moment(date);
	}

	if (toGMT3) {
		switch (localStorage.getItem('timeZone')) {
			case 'GMT-2':
				f_datetime.subtract(1, 'hour');
				break;
			case 'GMT-4':
				f_datetime.add(1, 'hour');
				break;
			case 'GMT-5':
				f_datetime.add(2, 'hours');
				break;
			default:
				break;
		}
	} else {
		switch (localStorage.getItem('timeZone')) {
			case 'GMT-2':
				f_datetime.add(1, 'hour');
				break;
			case 'GMT-4':
				f_datetime.subtract(1, 'hour');
				break;
			case 'GMT-5':
				f_datetime.subtract(2, 'hours');
				break;
			default:
				break;
		}
	}

	if (f_datetime.hour() < 1) {
		f_datetime.hour(23);
		f_datetime.minute(59);
	}

	return f_datetime.format(format)
};

export const useDebounce = (functionToUse, timeInMilliseconds = 500) => {
	let timeout;

	return (...params) => {
		const delayFunction = () => {
			clearTimeout(timeout);

			if (params) {
				functionToUse(...params);
			} else {
				functionToUse();
			}
		};
		clearTimeout(timeout);
		timeout = setTimeout(delayFunction, timeInMilliseconds);
	};
};